import { Injectable } from '@angular/core';
import {Resolve, RouterStateSnapshot, ActivatedRouteSnapshot} from '@angular/router';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import {StylesService} from '../services/styles.service';
import {KitService} from '../services/kit.service';


@Injectable()
export class LibraryResolver implements Resolve<any> {

  constructor(
    private stylesService: StylesService,
    private kitService: KitService
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {

    return this.kitService.getAll().flatMap(
      (allKits) => {
            return this.stylesService.fetchAll$().flatMap(
              (styles) => {
                return Observable.of({
                  kit: allKits,
                  styles: styles
                });
              }
            );
      }
    );
  }
}





// WEBPACK FOOTER //
// ./src/app/resolvers/library.resolver.ts